module.exports = __webpack_public_path__ + "static/media/inventory-audit-trail-white.7561b0d6.svg";